import FeeModulePage from "./FeeModulePage";
export default function MessFees() {
  return <FeeModulePage module="mess" />;
}
